import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, AuthCallback } from "@/context/AuthContext";
import { WaitlistProvider } from "@/context/WaitlistContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import ToolVideo from "@/pages/ToolVideo";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import Dashboard from "@/pages/Dashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import MimisDashboard from "@/components/MimisDashboard";
import { useEffect } from "react";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SiteLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);

const NotFound = () => (
  <main className="grid min-h-[80vh] place-items-center px-5 pt-24 text-center" data-testid="not-found-page">
    <div>
      <p className="font-display text-8xl font-extrabold tracking-tighter text-[#0066FF]">404</p>
      <p className="mt-3 text-lg text-[#52525b]">Questa pagina non esiste.</p>
      <Link to="/home" className="btn-blu mt-8 h-12 px-6 text-sm">Torna alla home</Link>
    </div>
  </main>
);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      {/* Dashboard ARI: pagina iniziale, senza header/footer del sito */}
      <Route path="/" element={<MimisDashboard />} />
      <Route path="/dashboard-spaziale" element={<MimisDashboard />} />
      <Route element={<SiteLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/tool/mimis-video" element={<ToolVideo />} />
        <Route path="/tool/video" element={<ToolVideo />} />
        <Route path="/abbonamento" element={<Account />} />
        <Route path="/account" element={<Account />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pagamento/successo" element={<PaymentSuccess />} />
        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/pagamento/annullato" element={<PaymentCancel />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WaitlistProvider>
          <SmoothScroll />
          <ScrollTop />
          <AppRouter />
          <Toaster position="top-center" richColors />
        </WaitlistProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
